import { ReferenceLocation, ReferenceLocationType } from '@/types';

export const TYPE_ORDER: ReferenceLocationType[] = ['ZIP', 'MUNICIPALITY', 'PLACE'];

export function sortLocations(a: ReferenceLocation, b: ReferenceLocation): number {
  const typeOrder = TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type);
  if (typeOrder !== 0) return typeOrder;
  if (a.type === 'ZIP') return parseInt(a.code, 10) - parseInt(b.code, 10);
  return a.name.localeCompare(b.name);
}

export function getOptionLabel(option: ReferenceLocation | string): string {
  if (typeof option === 'string') return option;
  if (option.type === 'ZIP') return option.name;
  if (option.type === 'PLACE' && option.postcode) return `${option.postcode} ${option.name}`;
  return option.foundBy ? `${option.name} ${option.foundBy}` : option.name;
}

export function isOptionEqual(opt: ReferenceLocation, val: ReferenceLocation): boolean {
  if (opt.type === 'PLACE') {
    return opt.type === val.type && opt.code === val.code && opt.postcode === val.postcode;
  }
  return opt.type === val.type && opt.code === val.code;
}
